<template>
  <div class="root">
    <div class="top-wrapper">
      <h2 :class="$route.query.exhibitionType">
        {{ title }}
      </h2>
      <p class="time">
        展览时间：{{ time }}
      </p>
    </div>

    <div class="swiper-root">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <img
            v-for="index of frameNumber"
            v-show="index - 1 === currentFrameIdxAA || index - 1 === currentFrameIdxAA - 1"
            :key="index"
            draggable="false"
            class="frame"
            :src="`${$publicPath}hand-rotate-frames/aa/${index}.jpg`"
            alt=""
            @load="onImgLoadAA(index - 1)"
            @error="onImgErrorAA(index - 1)"
          >
          <van-loading
            v-show="isLoadingAA"
            color="#1989fa"
            class="loading"
            type="spinner"
            size="3rem"
            vertical
          >
            <span style="font-size: 1rem;">
              {{ frameLoadProgressAA }}
            </span>
          </van-loading>
          <div
            class="entry"
            @click="onClickEntry('aa')"
          />
        </div>
        <div class="swiper-slide">
          <img
            v-for="index of frameNumber"
            v-show="index - 1 === currentFrameIdxAB || index - 1 === currentFrameIdxAB - 1"
            :key="index"
            draggable="false"
            class="frame"
            :src="`${$publicPath}hand-rotate-frames/ab/${index}.jpg`"
            alt=""
            @load="onImgLoadAB(index - 1)"
            @error="onImgErrorAB(index - 1)"
          >
          <van-loading
            v-show="isLoadingAB"
            color="#1989fa"
            class="loading"
            type="spinner"
            size="3rem"
            vertical
          >
            <span style="font-size: 1rem;">
              {{ frameLoadProgressAB }}
            </span>
          </van-loading>
          <div
            class="entry"
            @click="onClickEntry('ab')"
          />
        </div>
        <div class="swiper-slide">
          <img
            v-for="index of frameNumber"
            v-show="index - 1 === currentFrameIdxAC || index - 1 === currentFrameIdxAC - 1"
            :key="index"
            draggable="false"
            class="frame"
            :src="`${$publicPath}hand-rotate-frames/ac/${index}.jpg`"
            alt=""
            @load="onImgLoadAC(index - 1)"
            @error="onImgErrorAC(index - 1)"
          >
          <van-loading
            v-show="isLoadingAC"
            color="#1989fa"
            class="loading"
            type="spinner"
            size="3rem"
            vertical
          >
            <span style="font-size: 1rem;">
              {{ frameLoadProgressAC }}
            </span>
          </van-loading>
          <div
            class="entry"
            @click="onClickEntry('ac')"
          />
        </div>
        <div class="swiper-slide">
          <img
            v-for="index of frameNumber"
            v-show="index - 1 === currentFrameIdxAD || index - 1 === currentFrameIdxAD - 1"
            :key="index"
            draggable="false"
            class="frame"
            :src="`${$publicPath}hand-rotate-frames/ad/${index}.jpg`"
            alt=""
            @load="onImgLoadAD(index - 1)"
            @error="onImgErrorAD(index - 1)"
          >
          <van-loading
            v-show="isLoadingAD"
            color="#1989fa"
            class="loading"
            type="spinner"
            size="3rem"
            vertical
          >
            <span style="font-size: 1rem;">
              {{ frameLoadProgressAD }}
            </span>
          </van-loading>
          <div
            class="entry"
            @click="onClickEntry('ad')"
          />
        </div>
        <div class="swiper-slide">
          <img
            v-for="index of frameNumber"
            v-show="index - 1 === currentFrameIdxAE || index - 1 === currentFrameIdxAE - 1"
            :key="index"
            draggable="false"
            class="frame"
            :src="`${$publicPath}hand-rotate-frames/ae/${index}.jpg`"
            alt=""
            @load="onImgLoadAE(index - 1)"
            @error="onImgErrorAE(index - 1)"
          >
          <van-loading
            v-show="isLoadingAE"
            color="#1989fa"
            class="loading"
            type="spinner"
            size="3rem"
            vertical
          >
            <span style="font-size: 1rem;">
              {{ frameLoadProgressAE }}
            </span>
          </van-loading>
          <div
            class="entry"
            @click="onClickEntry('ae')"
          />
        </div>
      </div>
      <div class="swiper-pagination" />
    </div>
  </div>
</template>

<script>
import exhibitionData from '@/exhibitionData.js'
import Swiper from 'swiper/swiper-bundle.esm.js'
import 'swiper/swiper-bundle.css'

const frameNumber = 75

export default {
  data() {
    return {
      frameNumber,
      intervalId: null,

      loadedNumberAA: 0,
      currentFrameIdxAA: 0,
      imgStateListAA: new Array(frameNumber),
      isLoadingAA: true,

      loadedNumberAB: 0,
      currentFrameIdxAB: 0,
      imgStateListAB: new Array(frameNumber),
      isLoadingAB: true,

      loadedNumberAC: 0,
      currentFrameIdxAC: 0,
      imgStateListAC: new Array(frameNumber),
      isLoadingAC: true,

      loadedNumberAD: 0,
      currentFrameIdxAD: 0,
      imgStateListAD: new Array(frameNumber),
      isLoadingAD: true,

      loadedNumberAE: 0,
      currentFrameIdxAE: 0,
      imgStateListAE: new Array(frameNumber),
      isLoadingAE: true,

      exhibitionData,
    }
  },
  computed: {
    choosenExhibition() {
      return this.exhibitionData[this.$route.query.exhibitionType][this.$route.query.exhibitionId]
    },
    title() {
      return this.choosenExhibition.title.split('<br>').join('')
    },
    time() {
      return this.choosenExhibition.time
    },
    frameLoadProgressAA() {
      return Math.floor(this.loadedNumberAA / frameNumber * 100) + '%'
    },
    frameLoadProgressAB() {
      return Math.floor(this.loadedNumberAB / frameNumber * 100) + '%'
    },
    frameLoadProgressAC() {
      return Math.floor(this.loadedNumberAC / frameNumber * 100) + '%'
    },
    frameLoadProgressAD() {
      return Math.floor(this.loadedNumberAD / frameNumber * 100) + '%'
    },
    frameLoadProgressAE() {
      return Math.floor(this.loadedNumberAE / frameNumber * 100) + '%'
    },
  },
  mounted() {
    const that = this
    new Swiper('.swiper-root', {
      pagination: {
        el: '.swiper-pagination',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      on: {
        afterInit: function (e) {
        },
        slideChange: function(e) {
          // that.currentSlideIdx = e.activeIndex
        }
      }
    })

    this.intervalId = setInterval(() => {
      // 加载到一定程度再开始播放
      if (this.frameLoadProgressAA === '100%') {
        this.isLoadingAA = false
        // 跳过加载失败的图片
        do {
          this.currentFrameIdxAA++
        } while (this.imgStateListAA[this.currentFrameIdxAA] === false)
        if (this.currentFrameIdxAA >= frameNumber - 1) {
          clearInterval(this.intervalId)
        }
      }
      if (this.frameLoadProgressAB === '100%') {
        this.isLoadingAB = false
        // 跳过加载失败的图片
        do {
          this.currentFrameIdxAB++
        } while (this.imgStateListAB[this.currentFrameIdxAB] === false)
        if (this.currentFrameIdxAB >= frameNumber - 1) {
          clearInterval(this.intervalId)
        }
      }
      if (this.frameLoadProgressAC === '100%') {
        this.isLoadingAC = false
        // 跳过加载失败的图片
        do {
          this.currentFrameIdxAC++
        } while (this.imgStateListAC[this.currentFrameIdxAC] === false)
        if (this.currentFrameIdxAC >= frameNumber - 1) {
          clearInterval(this.intervalId)
        }
      }
      if (this.frameLoadProgressAD === '100%') {
        this.isLoadingAD = false
        // 跳过加载失败的图片
        do {
          this.currentFrameIdxAD++
        } while (this.imgStateListAD[this.currentFrameIdxAD] === false)
        if (this.currentFrameIdxAD >= frameNumber - 1) {
          clearInterval(this.intervalId)
        }
      }
      if (this.frameLoadProgressAE === '100%') {
        this.isLoadingAE = false
        // 跳过加载失败的图片
        do {
          this.currentFrameIdxAE++
        } while (this.imgStateListAE[this.currentFrameIdxAE] === false)
        if (this.currentFrameIdxAE >= frameNumber - 1) {
          clearInterval(this.intervalId)
        }
      }
    }, 41)
  },
  destroyed() {
    clearInterval(this.intervalId)
  },
  methods: {
    onImgLoadAA(idx) {
      this.loadedNumberAA++
      this.imgStateListAA[idx] = true
    },
    onImgLoadAB(idx) {
      this.loadedNumberAB++
      this.imgStateListAB[idx] = true
    },
    onImgLoadAC(idx) {
      this.loadedNumberAC++
      this.imgStateListAC[idx] = true
    },
    onImgLoadAD(idx) {
      this.loadedNumberAD++
      this.imgStateListAD[idx] = true
    },
    onImgLoadAE(idx) {
      this.loadedNumberAE++
      this.imgStateListAE[idx] = true
    },

    onImgErrorAA(idx) {
      this.loadedNumberAA++
      this.imgStateListAA[idx] = false
    },
    onImgErrorAB(idx) {
      this.loadedNumberAB++
      this.imgStateListAB[idx] = false
    },
    onImgErrorAC(idx) {
      this.loadedNumberAC++
      this.imgStateListAC[idx] = false
    },
    onImgErrorAD(idx) {
      this.loadedNumberAD++
      this.imgStateListAD[idx] = false
    },
    onImgErrorAE(idx) {
      this.loadedNumberAE++
      this.imgStateListAE[idx] = false
    },

    onClickEntry(id) {
      this.$router.push({ name: 'ExhibitionDetail', query: {
        exhibitionType: this.$route.query.exhibitionType,
        exhibitionId: id,
      } })
    },
  }
}
</script>

<style lang="less" scoped>
.root {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  > .top-wrapper {
    position: absolute;
    top: 2.5rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    line-height: 1.5;
    width: 13.66rem;
    z-index: 2;
    > h2 {
      font-size: 0.94rem;
      font-family: Source Han Sans CN;
      font-weight: 800;
      line-height: 1.41rem;
      &.theme {
        color: #18489D;
      }
      &.wuyiba {
        color: #F15835;
      }
      &.traditionModern {
        color: #2FB779;
      }
    }
    > .time {
      margin: 0.3rem 0 0;
      font-size: 0.72rem;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #909090;
    }
  }
  > .swiper-root {
    position: absolute;
    height: 100%;
    top: 0;
    width: 100%;
    > .swiper-wrapper {
      width: 100%;
      height: 100%;
      > .swiper-slide {
        position: relative;
        height: 100%;
        width: 100%;
        overflow: hidden;
        > .frame {
          position: absolute;
          height: 100%;
          left: 50%;
          transform: translateX(-50%);
        }
        > .loading {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        > div.entry {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          height: 60vh;
          width: 35vh;
          opacity: 0;
          cursor: pointer
        }
      }
    }
  }
}
</style>
